import templateUrl from './primary-diagnosis-field.html';

function frmPrimaryDiagnosisField() {
  return {
    restrict: 'A',
    scope: {
      model: '=',
      required: '&',
      cohort: '='
    },
    templateUrl: templateUrl
  };
}

export default frmPrimaryDiagnosisField;



/** WEBPACK FOOTER **
 ** ./src/app/forms/fields/primary-diagnosis-field.directive.js
 **/